/* OUTNEST pre-order: houdt knoplabels en levertijdtekst in sync na een variantwissel.
   De server (sections/main-product.liquid + snippets/outnest-preorder.liquid) rendert de juiste staat bij het laden.
   Bij een variantwissel haalt assets/global.js (VariantSelects.renderProductInfo) het prijsblok opnieuw op via
   section rendering en vervangt de inhoud van #price-<section> en #price-sticky-<section>. Dat blok bevat voor een
   pre-order variant een marker [data-preorder] (met data-preorder-btn en data-preorder-lead) en de verborgen
   property-input (name="properties[Verwachte levering]", form=...). De input gaat dus vanzelf mee; hier zetten we
   alleen het label van de knoppen en de levertijdtekst in de trust-regel. Ook de "Op voorraad"-tag in het
   "Goed om te weten"-blok (templates/product.json, custom liquid, .pf4__tag) wordt hier verborgen zolang de gekozen
   variant een pre-order is: die tag hangt aan product.available en is niet per variant. */
(function () {
  var PO_LABELS = {};
  var STOCK_RE = /^\s*(✓\s*)?(op voorraad|auf lager|lagernd)/i;

  function mainPrice() {
    return document.querySelector('.price-wrapper[id^="price-"]');
  }

  function buttons() {
    return document.querySelectorAll('.product__buy-buttons [name="add"], .sticky-add-to-cart [name="add"]');
  }

  function sync() {
    var wrap = mainPrice();
    if (!wrap) return;
    var marker = wrap.querySelector('[data-preorder]');
    var label = marker ? marker.getAttribute('data-preorder-btn') : '';
    var lead = marker ? marker.getAttribute('data-preorder-lead') : '';
    var normal = (window.variantStrings && window.variantStrings.addToCart) || '';

    if (label) PO_LABELS[label] = true;

    buttons().forEach(function (btn) {
      var span = btn.querySelector('span');
      if (!span || btn.disabled) return;
      var current = (span.textContent || '').trim();
      if (label) {
        if (current !== label) span.textContent = label;
        btn.setAttribute('data-button-text', label);
      } else if (PO_LABELS[current]) {
        span.textContent = normal;
        btn.setAttribute('data-button-text', normal);
      }
    });

    document.querySelectorAll('[data-po-normal]').forEach(function (el) {
      el.hidden = !!label;
    });
    document.querySelectorAll('[data-po-lead]').forEach(function (el) {
      el.hidden = !label;
      if (label && lead) el.textContent = lead;
    });
    document.querySelectorAll('.pf4__tag').forEach(function (el) {
      if (STOCK_RE.test(el.textContent || '')) el.hidden = !!label;
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    // microtask zodat we ná de eigen toggleAddButton van global.js draaien (die in dezelfde callback staat)
    Promise.resolve().then(function () {
      scheduled = false;
      sync();
    });
  }

  function start() {
    var targets = document.querySelectorAll('.price-wrapper[id^="price-"], [id^="price-sticky-"]');
    if (!targets.length || !('MutationObserver' in window)) return;
    var mo = new MutationObserver(schedule);
    targets.forEach(function (t) {
      mo.observe(t, { childList: true, subtree: true });
    });
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
